module.exports = __webpack_public_path__ + "img/Area-etering.b468065.jpg";